import {BlackPeriod} from './black-period.model';
import {PlatformAdvRightsValue} from './platform-values.model';

export class License {
  // This is general model for who want to reach license
  constructor(
    public id?: number,
    public name?: string,
    public serviceType?: string,
    public startTime?: number,
    public endTime?: number,
    public platforms?: string[],
    public regions?: string[],
    public currency?: string,
    public price?: number,
    public runType?: string,
    public boxOfficeType?: string,
    public exclusiveInterval?: number,
    public blackPeriods?: BlackPeriod[],
    public note?: string,
    public status?: string,
    public tba: boolean = false,
    public platformAdvertisements?: PlatformAdvRightsValue[],
    public preview?: boolean,
    public downloadable: boolean = false,
    public downloadDuration: number = 0,
    public estViewDuration?: number,
    public planCount?: number,
  ) {}
}
// Inline Model 1 {
//   blackPeriods (Array[BlackPeriod], optional),
//   boxOfficeType (string, optional) = ['A', 'B', 'C', 'D', 'E', 'Unknown', 'CurrentA', 'CurrentB', 'CurrentC', 'CurrentD', 'CurrentE', 'Library', 'LibraryMH', 'LibraryFranchise', 'Franchise', 'TopSMH', 'SMHA', 'SSMH', 'SMH', 'MH', 'NTR', 'NLTR', 'DTV', 'MFV', 'TVM', 'LibraryA', 'LibraryB', 'LibraryC', 'LibraryD', 'LibraryE', 'LibrarySMH'],
//   currency (string, optional) = ['TL', 'USD', 'EURO', 'YUAN'],
//   endTime (integer, optional),
//   exclusiveInterval (integer, optional),
//   id (integer, optional),
//   name (string, optional),
//   note (string, optional),
//   platforms (Array[string], optional),
//   price (number, optional),
//   regions (Array[string], optional),
//   runType (string, optional) = ['FR', 'RR', 'FirstPay', 'SecondPay', 'ThirdPay', 'Unknown'],
//   serviceType (string, optional) = ['TVOD', 'SVOD', 'EST', 'PAY', 'CATCHUP'],
//   startTime (integer, optional),
//   status (string, optional) = ['NONE', 'ACTIVE', 'INACTIVE', 'DELETED', 'EXPIRED'],
//   tba (boolean, optional)
//   }
